import moment from 'moment';

const state = {
    productType:'',
};

const getters = {
    productType: state => state.productType,
};

const actions = {
    setProductType({commit, state}, productType){
        commit('setStoreProductType', productType);
    }
};

const mutations = {
    setStoreProductType(state, productType){
        state.productType = productType;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
